import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import Theme from '../../styles/Theme/Theme';
import { NoData } from "../Global/Atomics/NoData";
import Spinner from "../Global/Atomics/Spinner";
import { Text } from '../Global/Atomics/Text';
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import { RadarChartComponent } from "../Global/Charts/RadarChartComponent";
import CustomIcon from "../Global/Icons/CustomIcon";

export const SlaMatchingWidget = () => {
    const { data: slaData, isFetching: slaIsFetching } = useFetch(query.path.verticalSla, 'getVerticalSla', null, 300000);
    const radarData = [];
    const iconsIds = [];
    if (!slaIsFetching && SLAMatchingData) {
        Object.keys(SLAMatchingData)?.forEach((key, index) => {
            radarData.push({
                name: SLAMatchingData[key].Label,
                sla: SLAMatchingData[key].SLA,
                sla_obj: SLAMatchingData[key].SLA_OBJ,
                sla_top: 100,
            })

            iconsIds.push({
                icon: SLAMatchingData[key].Icon
            })
        })
    };

    return (
        <WidgetCard display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} style={{ overflow: 'hidden' }}>
            <div style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', marginBottom: Theme.spacing.videowall.xs, flexShrink: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                    <CustomIcon icon={'HoldingHands'} iconSize='md' color={Theme.color['teal-4']} />
                    <Text color={Theme.color['coolgray-12']} marginLeft={Theme.spacing.videowall.xs} fontSize='text_md' fontWeight={Theme.typography.weight.medium} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>SLA Matching</Text>
                </div>
                <Text color={Theme.color['coolgray-10']} fontSize='text_md' fontWeight={Theme.typography.weight.regular} style={{ whiteSpace: 'nowrap', flexShrink: 0, marginLeft: Theme.spacing.videowall.xs }}>Last 7 days</Text>
            </div>
            <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                {!slaIsFetching ?
                    radarData.length > 0 ?
                        <RadarChartComponent data={radarData} icons={iconsIds} />
                        : <div style={{ height: '100%', alignContent: 'center' }}><NoData /></div>
                    : <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>
                }
            </div>
        </WidgetCard>
    )
};

const SLAMatchingData = {
    "Living.Communication": {
        "SLA": 100,
        "SLA_OBJ": 80,
        "Label": 'Communication',
        "Icon": 'MobileSignal'
    },
    "Mobility.Transportation": {
        "SLA": 88,
        "SLA_OBJ": 80,
        "Label": 'Transportation',
        "Icon": 'Transports'
    },
    "Living.Public Space": {
        "SLA": 88,
        "SLA_OBJ": 80,
        "Label": 'Public Space',
        "Icon": 'PublicSpace'
    },
    "Mobility.Traffic": {
        "SLA": 81,
        "SLA_OBJ": 70,
        "Label": 'Traffic',
        "Icon": 'Car'
    },
    "Environment.Solid Waste": {
        "SLA": 90,
        "SLA_OBJ": 70,
        "Label": 'Waste',
        "Icon": 'Trash'
    },
    "Mobility.Parking": {
        "SLA": 95,
        "SLA_OBJ": 70,
        "Label": 'Parking',
        "Icon": 'Parking'
    },
    "Living.Illumination": {
        "SLA": 89,
        "SLA_OBJ": 70,
        "Label": 'Illumination',
        "Icon": 'Lamp'
    },
    "People.Emergency": {
        "SLA": 96,
        "SLA_OBJ": 70,
        "Label": 'Emergency',
        "Icon": 'Medical'
    },
    "Environment.Energy": {
        "SLA": 88,
        "SLA_OBJ": 70,
        "Label": 'Energy',
        "Icon": 'Bolt'
    },
    "Environment.Water": {
        "SLA": 92,
        "SLA_OBJ": 80,
        "Label": 'Water',
        "Icon": 'WaterDrop'
    }
};